import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  ViewChild,
} from '@angular/core';
import { IoniconsFilled, IoniconsOutline, WTextViewMode } from '@pt/pt-models';
import { WidgetDialogService } from '../../services/widget-dialog.service';
import { TranslateService } from '@ngx-translate/core';
import { of } from 'rxjs';

@Component({
  selector: 'pt-widget-input-note',
  template: `
    <div *ngIf="label" class="widget-input-note--label">{{ label }}</div>

    <div class="note-container--no-preview">
      <textarea
        [ngClass]="{ 'd-none': viewMode === WTextViewMode.DIALOG || !editable }"
        rows="5"
        class="w-100"
        #noteRef
        autocomplete="off"
        [(ngModel)]="currentNote"
        (ngModelChange)="changeNote.emit($event)"
      ></textarea>
    </div>
  `,
  styles: [
    `
      .note-container--no-preview {
        position: relative;
        width: auto;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        cursor: pointer;
        flex-wrap: nowrap;
      }

      .widget-input-note--label {
        font-size: 12px;
        margin-top: 10px;
        margin-bottom: 0;
        border: 1px solid #bbbbbb;
        padding: 5px;
        min-height: 50px;
        width: 100%;
      }
    `,
  ],
})
export class WidgetInputNoteComponent implements OnChanges {
  @Input() note: string;
  @Input() editable: boolean;
  @Input() dialogTitle: string;
  @Input() label: string;
  @Input() viewMode: WTextViewMode;
  @Output() changeNote = new EventEmitter<string>();
  @Output() changeNoteAndSave = new EventEmitter<string>();
  @Output() closeEditor = new EventEmitter();

  @ViewChild('noteRef', { static: true }) noteRef: ElementRef<any>;
  WTextViewMode = WTextViewMode;
  IconNote = IoniconsFilled.doc;
  IconEdit = IoniconsOutline.edit;

  currentNote: string;
  showPreview = true;

  constructor(
    private widgetDialogService: WidgetDialogService,
    private translateService: TranslateService
  ) {}

  ngOnChanges(): void {
    this.currentNote = this.note;
    if (this.editable) {
      switch (this.viewMode) {
        case WTextViewMode.DIALOG:
          this.openHelpDialog(this.note);
          break;
        case WTextViewMode.TEXTAREA:
          if (this.noteRef) {
            setTimeout(() => {
              this.noteRef.nativeElement.focus();
            });
          }
      }
    }

    this.showPreview = this.viewMode === WTextViewMode.DIALOG || !this.editable;
  }

  openHelpDialog(note: string) {
    console.log('openHelpDialog(note: string) ');
    const dialog = this.widgetDialogService.runTextArea(
      of(this.dialogTitle),
      note,
      this.editable
    );
    dialog.subscribe(
      (value) => {
        if (this.note !== value) {
          this.note = value;
          this.changeNoteAndSave.emit(this.note);
        } else {
          this.closeEditor.emit();
        }
      },
      () => {
        this.closeEditor.emit();
      }
    );
  }
}
